var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{attrs:{"titleSize":0,"title":"Correos enviados"}}),_c('user-inbox-notification-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }